const API_BASE = process.env.REACT_APP_API_URL;
const SUBCATEGORIA_API_URL = `${API_BASE}Subcategoria`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export async function getSubcategoriasByCategoria(categoriaId) {
  try {
    const res = await fetch(`${SUBCATEGORIA_API_URL}/categoria/${categoriaId}`, {
      headers: getAuthHeaders()
    });
    
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    
    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Error en getSubcategoriasByCategoria:', error);
    throw error;
  }
}

export function createSubcategoria(categoriaId) {
  return async (values, onDone) => {
    try {
      await fetch(SUBCATEGORIA_API_URL, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          ...values,
          categoria_id: categoriaId
        })
      });
      onDone(true);
    } catch {
      onDone(false);
    }
  };
}

export function editSubcategoria() {
  return async (row, values, onDone) => {
    try {
      await fetch(`${SUBCATEGORIA_API_URL}/${row.id_subcategoria}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          ...row,
          ...values
        })
      });
      onDone(true);
    } catch {
      onDone(false);
    }
  };
}

export function deleteSubcategoria() {
  return async (row, onDone) => {
    try {
      await fetch(`${SUBCATEGORIA_API_URL}/${row.id_subcategoria}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      onDone(true);
    } catch {
      onDone(false);
    }
  };
}

export async function getSubcategorias() {
  const res = await fetch(SUBCATEGORIA_API_URL, {
    headers: getAuthHeaders()
  });
  return await res.json();
}
